import Accordion from './Accordion.svelte';
import Button from './Button.svelte';
import Divider from './Divider.svelte';
import Embed from './Embed.svelte';
import FormQuestion from './FormQuestion.svelte';
import GridColumn from './GridColumn.svelte';
import GridRow from './GridRow.svelte';
import Icon from './Icon.svelte';
import Image from './Image.svelte';
import ImageSlider from './ImageSlider.svelte';
import List from './List.svelte';
import MediaQuestion from './MediaQuestion.svelte';
import MultipleChoiceQuestion from './MultipleChoiceQuestion.svelte';
import TestimonialSlider from './TestimonialSlider.svelte';
import Text from './Text.svelte';
import TextQuestion from './TextQuestion.svelte';
import Video from './Video.svelte';
import Webinar from './Webinar.svelte';

// Types
import type { ComponentType } from 'svelte';

const mapping: { [componentType: string]: ComponentType } = {
    accordion: Accordion,
    button: Button,
    divider: Divider,
    embed: Embed,
    gridColumn: GridColumn,
    gridRow: GridRow,
    icon: Icon,
    image: Image,
    list: List,
    questionForm: FormQuestion,
    questionMedia: MediaQuestion,
    questionMultipleChoice: MultipleChoiceQuestion,
    questionText: TextQuestion,
    sliderImage: ImageSlider,
    sliderTestimonial: TestimonialSlider,
    text: Text,
    video: Video,
    webinar: Webinar,
};

export default (componentType: string, content: any) => {
    if (componentType === 'media') {
        if (content.srcType === 'image') {
            return mapping.image;
        } else if (content.srcType === 'video') {
            return mapping.video;
        }
    }

    return mapping[componentType];
};
